<script>
	export let id;
	export let src;
	$: cssClass = $$props.class || "";
  $: cssStyle = $$props.style || "";
  
  $: notResponsive = cssClass.indexOf("responsive") === -1

</script>

<img class="lazy-img {cssClass} {notResponsive ? 'lazy-img-notresponsive' : ''}" {id} style={cssStyle} data-lazy-src={src} alt="" />

<style>
  .lazy-img {
    display: block;
    min-width: 1px;
    min-height: 1px;
  }
</style>
